import { useContext, useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router";
import SelectModeSubbarOpener from "../../Components/Banners/SelectModeBanner/opener";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { routePaths } from "../../Router/router";
import DriveSelectModeBanner from "../../Components/Banners/DriveSelectModeBanner";
import { ModalContext } from "../../Components/Modals";
import ModalClipUpdate from "../../Components/Modals/ModalClipUpdate";

function Drive() {
  const [selectedItems, setSelectedItems] = useState<DbAssetObjectInfos[]>([]);
  const location = useLocation();

  const handleCloseClick = () => {
    setSelectedItems([]);
  };

  const isDriveHome = useMemo(() => {
    return (
      location.pathname !== `${routePaths.drive.path}/${routePaths.driveTrash.path}` &&
      location.pathname !== `${routePaths.drive.path}/${routePaths.driveExternalAccess.path}` &&
      location.pathname !== `${routePaths.drive.path}/${routePaths.driveAdvancedSearch.path}`
    );
  }, [location]);

  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  useEffect(() => {
    localStorage.getItem("clipUpdateClosedForever") !== "true" && openModal && openModal(ModalClipUpdate);
  }, [openModal]);

  return (
    <DashboardLayout
      maxWidth={false}
      noScroll
      Banner={
        <DriveSelectModeBanner
          items={selectedItems}
          setItems={setSelectedItems}
          handleCloseClick={handleCloseClick}
          layer={ObjectLayer.Asset}
          itemsCanBeShared={true}
        />
      }
    >
      <Outlet context={{ selectedItems: selectedItems, setSelectedItems: setSelectedItems }} />
      <SelectModeSubbarOpener selectedObjects={selectedItems} />
    </DashboardLayout>
  );
}

export default Drive;
